import { Fragment, useCallback, useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import infoRound from '~/assets/icons/info_round.svg';
import { playSound, Sound } from '~/assets/sounds';
import { Button, ButtonColors, ButtonHeight } from '~/components/ui/Button';
import {
	NumberplatePreview,
	NumberPlatePreviewSize,
} from '~/components/ui/NumberplatePreview';
import { Text } from '~/components/ui/Text';
import { rage } from '~/rage';
import { ExchangeItemType } from '~/shared';
import {
	HouseClasses,
	houseClassNames,
	IListItem,
	IListItemElem,
	ListItemIcons,
} from './ListItem.model';
import {
	StyledContainer,
	StyledHintContainer,
	StyledHintDivider,
	StyledHintHeading,
	StyledHintInfoContainer,
	StyledHouseClassContainer,
	StyledHoverBackground,
	StyledInfoContainer,
} from './ListItem.styled';

const ListItem: React.FC<IListItem & IListItemElem> = ({
	id,
	type,
	text,
	number,
	mode,
	scrollOffset,
	active,
	onClick,
	selectionHidden,
	owned = true,
	onMouseEnter,
	...props
}: IListItem & IListItemElem) => {
	const [homeHintVisible, setHomeHintVisible] = useState<boolean>(false);

	const handleAdd = useCallback(() => {
		rage.exchange
			.placeItem(id)
			.catch((err) => rage.notifications.showException(err));
	}, [id]);

	const handleRemove = useCallback(() => {
		rage.exchange
			.removePlacedItem(id)
			.catch((err) => rage.notifications.showException(err));
	}, [id]);

	const handleHintVisible = useCallback(
		(value: boolean) => {
			if (type === ExchangeItemType.House) {
				setHomeHintVisible(value);
			}
		},
		[type],
	);

	return (
		<Fragment>
			<StyledContainer
				$mode={mode}
				$active={active}
				onClick={(e) => {
					onClick?.(e);
					playSound(Sound.ClickButton);
				}}
				$selectionHidden={selectionHidden}
				onMouseEnter={(e) => {
					if (typeof onMouseEnter !== 'undefined') {
						onMouseEnter(e);
					}
					playSound(Sound.LinkCursor);
				}}
				{...props}
			>
				<StyledHoverBackground />
				{mode === 'remove' && <img src={ListItemIcons[type]} />}
				<Text>{text}</Text>
				<StyledInfoContainer>
					{number && (
						<NumberplatePreview
							numberPlate={number}
							size={NumberPlatePreviewSize.Size30}
							dark
						/>
					)}
					{type === ExchangeItemType.Vehicle ||
					type === ExchangeItemType.House ? (
						<Button
							color={ButtonColors.Default}
							height={ButtonHeight.Height30}
							onMouseEnter={() => {
								handleHintVisible(true);
							}}
							onMouseLeave={() => handleHintVisible(false)}
							style={{ zIndex: 2, width: 30 }}
						>
							<img src={infoRound} width={16} height={16} />
						</Button>
					) : null}
				</StyledInfoContainer>
				{owned ? (
					mode === 'add' ? (
						<Button
							color={ButtonColors.Select2}
							height={ButtonHeight.Height30}
							onClick={() => {
								handleAdd();
								playSound(Sound.ClickButton);
							}}
							style={{ zIndex: 2 }}
						>
							<Text>Добавить</Text>
						</Button>
					) : (
						<Button
							color={ButtonColors.Default}
							height={ButtonHeight.Height30}
							onClick={() => {
								handleRemove();
								playSound(Sound.ClickButton);
							}}
							style={{ zIndex: 2, padding: '0 10px' }}
						>
							<Text>Убрать</Text>
						</Button>
					)
				) : null}
			</StyledContainer>
			<CSSTransition
				in={homeHintVisible}
				timeout={500}
				classNames={'hint'}
				unmountOnExit
			>
				<StyledHintContainer
					$mode={mode}
					style={{ marginTop: scrollOffset ? -scrollOffset - 10 : -10 }}
				>
					<StyledHintHeading>
						<Text style={{ fontSize: 14, fontWeight: 500 }}>
							Информация о доме
						</Text>
						<StyledHouseClassContainer $class={HouseClasses.Low}>
							<Text>{houseClassNames[HouseClasses.Low]}</Text>
						</StyledHouseClassContainer>
					</StyledHintHeading>
					<StyledHintDivider style={{ marginTop: 20, marginBottom: 20 }} />
					<StyledHintInfoContainer>
						<Text>Владелец</Text>
						<Text>stdian</Text>
						<Text>Обслуживаниеа</Text>
						<Text>1 500 д.</Text>
						<Text>Гаражные места</Text>
						<Text>10 м.</Text>
					</StyledHintInfoContainer>
				</StyledHintContainer>
			</CSSTransition>
		</Fragment>
	);
};

export { ListItem };
